// Import Packages
import React, {useState, useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import {useRecoilState, useSetRecoilState} from "recoil";
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Import Material UI
import StepConnector from '@material-ui/core/StepConnector';
import StepLabel from '@material-ui/core/StepLabel';
import StepIcon from '@material-ui/core/StepIcon';
import {Step, StepButton, Stepper, SvgIcon} from "@material-ui/core";
import {withStyles, makeStyles} from '@material-ui/core/styles';
import Check from '@material-ui/icons/Check';
import SettingsIcon from '@material-ui/icons/Settings';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import DoneIcon from '@material-ui/icons/Done';
import Divider from '@material-ui/core/Divider';

// Import Pages
import Search from "../../../Search/Search";
import Apps from "./Apps/Apps";
import Triggers from "./Triggers/Triggers";
import {alertState, triggerConf} from "../../../../recoil-store/recoil-state";
import Connector from "./Connector/Connector";
import Setup from "./Setup/Setup";

// Import CSS
import './triggerStatic.css';

const useStyles = makeStyles(() => ({
    root: {
        "& .MuiStepIcon-active": {color: "#ffffff"},
        "& .MuiStepIcon-completed": {color: "#5ac283"},
        "& .Mui-disabled .MuiStepIcon-root": {color: "#e0e3ea"},
        "& .MuiStepIcon-active .MuiStepIcon-text": {fill: "#8e93a5"},
        "& .MuiStepIcon-text": {fontWeight: "bold", fontSize: "15px"}
    },
    valid: {
        "& .MuiStepIcon-active": {color: "#5ac283"},
        "& .MuiStepIcon-completed": {color: "#5ac283"},
        "& .Mui-disabled .MuiStepIcon-root": {color: "#e0e3ea"},
        "& .MuiStepIcon-text": {fontWeight: "bold", fontSize: "15px"}
    },
    label: {
        "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {marginTop: '3px', fontSize: '10px'}
    }
}));

const colorlibConnector = withStyles({
    alternativeLabel: {
        top: 22,
    },
    active: {
        '& $line': {
            backgroundColor: '#5ac283',
        }
    },
    completed: {
        '& $line': {
            backgroundColor: '#5ac283',
        }
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);

const useColorLibStepIconStyles = makeStyles({
    root: {
        color: '#eaeaf0',
        //display: 'flex',
        //height: 22,
        //alignItems: 'center',

        backgroundColor: '#e0e3ea',
        zIndex: 1,
        // color: '#fff',
        width: 40,
        height: 40,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        color: '#eaeaf0',
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        border: '1px solid #8e93a5'
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    completed: {
        color: '#eaeaf0',
        backgroundColor: '#5ac283',
        zIndex: 1,
        fontSize: 18,
    },
});

function ColorLibStepIcon(props, isValid, activeStep) {
    const classes = useColorLibStepIconStyles();
    const {active, completed} = props;

    const icons = {
        1: <StepIcon icon={completed ? <DoneIcon/> : 1} active={active} completed={completed}/>,
        2: <StepIcon icon={completed ? <DoneIcon/> : 2} active={active} completed={completed}/>,
        3: <StepIcon icon={completed ? <DoneIcon/> : 3} active={active} completed={completed}/>,
        4: <StepIcon icon={completed ? <DoneIcon/> : 4} active={active} completed={completed}/>
    };

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed || (activeStep === props.icon && isValid),
            })}
        >
            {icons[String(props.icon)]}
        </div>
    );
}


ColorLibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
};


export default function TriggerStatic({
                                          variables,
                                          setOpenVariable,
                                          triggerConfig,
                                          setTriggerConf,
                                          isValid,
                                          setIsValid,
                                          activeStep,
                                          setActiveStep,
                                          automVersionId,
                                          automId
                                      }) {
    const [apps, setApps] = useState([]);
    const [triggers, setTriggers] = useState({});
    const [appCredentials, setAppCredentials] = useState([]);
    const [completed, setCompleted] = useState({});
    const [checked, setChecked] = useState(!!triggerConfig?.setup?.conditions?.length);
    const setAlert = useSetRecoilState(alertState);
    const label = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC."
    const {t} = useTranslation();
    const appsLabel = t(label + "APPLICATIONS");
    const triggerLabel = t(label + "TRIGGER");
    const connectorLabel = t(label + "CONNECTOR");
    const conditionLabel = t(label + "CONDITION");
    const steps = getSteps();
    const c = useStyles();

    // useEffect(() => {
    //     if (triggerConfig) {
    //         let step = 0;
    //         let valid = false;
    //         if (Object.keys(triggerConfig.app).length > 0) {
    //             valid = true;
    //             if (Object.keys(triggerConfig.trigger).length > 0) {
    //                 step = 1;
    //                 if (Object.keys(triggerConfig.connector).length > 0) {
    //                     step = 2;
    //                     if (Object.keys(triggerConfig.setup).length > 0) {
    //                         if (triggerConfig.setup?.conditions?.length) {
    //                             setChecked(true);
    //                         }
    //                         step = 3;
    //                     }
    //                 }
    //             }
    //         }
    //         setIsValid(valid);
    //         setActiveStep(step);
    //         //handleComplete(step)
    //     }
    // }, []);

    function getSteps() {
        return [appsLabel, triggerLabel, connectorLabel, conditionLabel];
    }

    // setAlert(alert => ({
    //     ...alert,
    //     show: true,
    //     message: t(`MESSAGES.TRIGGER-STATIC.PLEASE-SELECT-AT-LEAST-ONE-APP`),
    //     severity: 'error'
    // }))

    const totalSteps = () => {
        return steps.length;
    };

    const isLastStep = (step) => {
        step = step ? step : activeStep;
        return step === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const handleNext = (step) => {
        step = step ? step : activeStep;
        const newActiveStep =
            isLastStep(step) && !allStepsCompleted()
                ? // It's the last step, but not all steps have been completed,
                // find the first step that has been completed
                steps.findIndex((_step, i) => !(i in completed))
                : step + 1;
        setActiveStep(newActiveStep);
    };

    const handleReset = () => {
        setActiveStep(0);
        setCompleted({});
    };

    const handleResetExcept = (step) => {
        setActiveStep(step + 1);
        setCompleted({[step]: true});
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const handleComplete = (step) => {
        step = step ? step : activeStep;
        const newCompleted = completed;
        newCompleted[step] = true;
        setCompleted(newCompleted);
        if (step !== 3) handleNext(step);
    };

    const handleSetSelectedApp = async (item) => {
        setTriggerConf(conf => ({
            ...conf,
            app: item,
            trigger: {},
            connector: {},
            setup: {
                fields: {},
                conditions: [],
                inputs: {}
            }
        }))
        setIsValid(true);
        setChecked(false);
    }

    const handleSetSelectedTrigger = async (name = "", item) => {
        if (name) item.name = name;
        setTriggerConf(conf => ({
            ...conf,
            trigger: {id: item.id, trigger_action_id: item.trigger_action_id, type: item.type, name: item.name},
            setup: {
                fields: {},
                conditions: [],
                inputs: {}
            }
        }))
        setIsValid(true);
        setChecked(false);
    }

    const handleSetSelectedConnector = async (item) => {
        setTriggerConf(conf => ({
            ...conf,
            connector: {id: item.id, name: item.name},
            setup: {
                fields: {},
                conditions: [],
                inputs: {}
            }
        }))
        setIsValid(true);
    }

    const handleSetSelectedSetup = async (item) => {
        setTriggerConf(conf => ({
            ...conf,
            setup: item
        }))
    }

    function getStepContent(step) {
        switch (step) {
            case 0:
                return <Apps apps={apps} setApps={setApps} selectedAppId={triggerConfig?.app?.id}
                             handleSetSelectedApp={handleSetSelectedApp}/>;
            case 1:
                return <Triggers selectedAppId={triggerConfig?.app?.id} triggers={triggers} setTriggers={setTriggers}
                                 selectedTriggerId={triggerConfig?.trigger?.id}
                                 handleSetSelectedTrigger={handleSetSelectedTrigger}/>;
            case 2:
                return <Connector selectedApp={triggerConfig?.app} appCredentials={appCredentials}
                                  setAppCredentials={setAppCredentials}
                                  selectedConnectorId={triggerConfig?.connector?.id}
                                  handleSetSelectedConnector={handleSetSelectedConnector}/>;
            case 3:
                return <Setup variables={variables} setOpenVariable={setOpenVariable}
                              handleSetSelectedSetup={handleSetSelectedSetup} setTriggerConf={setTriggerConf}
                              checked={checked} setChecked={setChecked} triggerConfig={triggerConfig}
                              automVersionId={automVersionId} automId={automId}/>;
            default:
                return 'Unknown step';
        }
    }

    return (
        <div style={{height: "100%"}}>
            <Stepper style={{padding: '0px 0px 24px 0px'}} className={isValid ? c.valid : c.root} alternativeLabel
                     activeStep={activeStep} connector={<colorlibConnector/>}>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel className={c.label}
                                   StepIconComponent={(e) => ColorLibStepIcon(e, isValid, activeStep + 1)}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <div className="trigger-configuration-content">
                {getStepContent(activeStep)}
            </div>
        </div>
    );
}
